import { FC } from "react";
import { SurveyAnswerType } from "../../EnterpriseGPTApi/EnterpriseGPTApiV1Client";
import { Field, Radio, RadioGroup, Rating, Textarea } from "@fluentui/react-components";

export interface SurveyAnswerViewProps {
    id: string;
    question: string;
    answerType: SurveyAnswerType;
    options?: string[];
    onAnswer: (id: string, answer: string, type: SurveyAnswerType) => void;
}

// survey structure
const SurveyAnswerView: FC<SurveyAnswerViewProps> = ({ id, question, answerType, options, onAnswer }: SurveyAnswerViewProps) => {
    switch (answerType) {
        // plain-text question
        case SurveyAnswerType.Text:
            return <Field label={`${id}) ${question}`}>
                <Textarea size="large" onChange={(ev) => onAnswer(id, ev.target.value, answerType)} />
            </Field>;
        // single-value question (radio button)
        case SurveyAnswerType.SingleValue:
            return <Field label={`${id}) ${question}`}>
                <RadioGroup onChange={(_, data) => { onAnswer(id, data.value, answerType) }}>
                    {options?.map((o, i) => <Radio key={`questionOption${id}${i}`} label={o} value={o} />)}
                </RadioGroup>
            </Field>
        // rating question
        case SurveyAnswerType.Rating:
            return <Field label={`${id}) ${question}`}>
                <Rating color="brand" onChange={(_, data) => onAnswer(id, String(data.value), answerType)} />
            </Field>;
    }
}

export default SurveyAnswerView;